function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP CTA component for home page
 * 
 */
import * as React from 'react';
import './WhatIs.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class WhatIs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const {
      content,
      ctaTitle,
      ctaContent,
      ctaLinkTitle,
      ctaLinkUrl
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      className: "WhatIs",
      children: [/*#__PURE__*/_jsx("div", {
        className: "content",
        dangerouslySetInnerHTML: {
          __html: content
        }
      }), /*#__PURE__*/_jsxs("div", {
        className: "cta",
        children: [/*#__PURE__*/_jsx("h3", {
          className: "title",
          children: ctaTitle
        }), /*#__PURE__*/_jsx("div", {
          dangerouslySetInnerHTML: {
            __html: ctaContent
          }
        }), /*#__PURE__*/_jsx("a", {
          className: "button reverse",
          role: "button",
          href: ctaLinkUrl,
          target: "_blank",
          rel: "noopener noreferrer",
          children: ctaLinkTitle
        })]
      })]
    });
  }
}
_defineProperty(WhatIs, "defaultProps", {
  content: 'ipso facto',
  ctaTitle: '<p>This is some HTML content</p>',
  ctaContent: '<p>This is some HTML content</p>',
  ctaLinkTitle: '<p>This is some HTML content</p>',
  ctaLinkUrl: '<p>This is some HTML content</p>'
});
export default WhatIs;